module.exports = __webpack_public_path__ + "static/media/non_disponibile.4ccbc550.png";